import {
  greenLight,
  redLight,
  yellowLight,
} from '@crehana/ui/dist/styles/colors';

// f(x)=0.0004(x - 46)^3 + 39

export const levels = [
  {
    name: 'Principiante',
    data: [
      { category: 0, value: 0 },
      { category: 5, value: 11.43 },
      { category: 10, value: 20.3 },
      { category: 15, value: 27 },
      { category: 20, value: 31.9 },
      { category: 25, value: 35.3 },
      { category: 30, value: 37.3 },
      { category: 40, value: 38.9 },
      { category: 50, value: 39 },
      { category: 60, value: 40 },
      { category: 75, value: 48.75 },
      { category: 77.07, value: 51 },
    ],
    stroke: redLight,
  },
  {
    name: 'Intermedio',
    data: [
      { category: 77.07, value: 51 },
      { category: 80, value: 54.7 },
      { category: 85, value: 62.72 },
      { category: 90, value: 73 },
      { category: 92.7, value: 80 },
    ],
    stroke: yellowLight,
  },
  {
    name: 'Avanzado',
    data: [
      { category: 93.17, value: 81 },
      { category: 97, value: 92 },
      { category: 100, value: 100 },
    ],
    stroke: greenLight,
  },
];
